import type { DeviceType } from "@/app/platform/types";

export function getDeviceTypeFromUserAgent(): DeviceType {
  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) return "iOS";

  if (/Android/.test(navigator.userAgent)) return "Android";

  return "Other";
}
